import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';
import type {
  PayHubCashierContractsCreateRequisiteRequest as CreateRequisiteRequest,
  PayHubCashierContractsCreateRequisiteResponse,
  PayHubCashierContractsSendOTPResponse,
  PayHubCashierContractsVerifyOTPResponse as VerifyCodeResponse,
} from 'store/models';
import { WIDGET_API } from 'utils/constants';

type VerifyCodeRequestProps = {
  contactType: string;
};

export interface SendCodeResponse {
  success?: boolean;
  maxRequestCount?: number;
  blockDuration?: string;
}

export interface CreateRequisiteResponse {
  requisiteId?: number | null;
}

export const accountManagementAPI = createApi({
  reducerPath: 'accountManagementAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      createRequisite: builder.query<CreateRequisiteResponse, CreateRequisiteRequest>({
        query: (body) => ({
          url: '/requisite/create',
          method: 'POST',
          body,
        }),
        transformResponse: (response: PayHubCashierContractsCreateRequisiteResponse): CreateRequisiteResponse => ({
          requisiteId: response.requisite_id,
        }),
      }),
      sendCode: builder.query<SendCodeResponse, VerifyCodeRequestProps>({
        query: ({ contactType }) => ({
          url: '/otp/send',
          method: 'POST',
          body: {
            contact_type: contactType,
          },
        }),
        transformResponse: (response: PayHubCashierContractsSendOTPResponse): SendCodeResponse => ({
          success: response.success,
          maxRequestCount: response.max_request_count || undefined,
          blockDuration: response.block_duration || undefined,
        }),
      }),
      verifyCode: builder.mutation<VerifyCodeResponse, string>({
        query: (otp) => ({
          url: '/otp/verify',
          method: 'POST',
          body: {
            otp,
          },
        }),
      }),
    };
  },
});

export const { useLazyCreateRequisiteQuery, useLazySendCodeQuery, useVerifyCodeMutation } = accountManagementAPI;
